<template>
    <div class="bg-white rounded-xl border border-gray-200 shadow-sm px-6 py-5 transition hover:shadow-md">
        <div class="flex items-center justify-between gap-4 mb-4">
            <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-400">{{ title }}</h2>
            <div v-if="$slots.action">
                <slot name="action" />
            </div>
        </div>
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, required: true },
    },
};
</script>
